import React from 'react';

import CreateVMForm from './CreateVMForm';

const CreateVM = () => {
  return <CreateVMForm />;
};

export default CreateVM;
